import * as React from 'react';
import { WatchlistContext } from 'context/WatchlistContext';

export const useWatchlist = () => {
  const watchlist = React.useContext(WatchlistContext);
  if (!watchlist) throw new Error('useWatchlist must be used within WatchlistProvider');
  return watchlist;
};
